export default "__VITE_ASSET__CbECsYTc__"